import CompleteClientForMissionDialog from 'components/companies/CompleteClientForMissionDialog';
import InvoiceImportRunProvider from 'components/invoiceImport/InvoiceImportRunProvider';
import MailComposerProvider from 'components/mail/MailComposerProvider';
import Modal from 'components/modal/portal';
import SessionExpiredModal from 'components/modal/SessionExpiredModal';
import SlideOver from 'components/SlideOver/portal';
import { ContextProvider } from 'context/Context';
import { useLocation } from 'react-router-dom';
import Routes from 'routes';
function App() {
  const location = useLocation();
  const tokenURL = location.search.split('=')[1];
  return (
    <ContextProvider>
      <InvoiceImportRunProvider>
        <MailComposerProvider>
          <SessionExpiredModal />
          <Modal />
          <SlideOver />
          <CompleteClientForMissionDialog />
          <Routes />
        </MailComposerProvider>
      </InvoiceImportRunProvider>
    </ContextProvider>
  );
}

export default App;
